import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Tooltip } from '@mui/material';
import { Typography } from '@totalsoft/rocket-ui';
import { CalendarCheckbox, CalendarTableCellChip, ColoredCircle } from './OfferPaymentPlanStyles';

function ScheduleTableCell({ rowIdx, cellData, fixedTableColumns, handleRowPropertyChange, scheduleCellParamColumns, selectedOptions }) {
  const { t } = useTranslation();

  const labelValues = scheduleCellParamColumns?.filter(column => column.controlType !== 'BOOL' && cellData[column.cellParamName]);

  const handleCheckboxChange = paramName => event => {
    handleRowPropertyChange(rowIdx, paramName, event.target.checked);
  };

  return (
    <Grid container flexDirection={'column'}>
      <Grid item xs={12}>
        <CalendarCheckbox
          checked={Boolean(cellData[fixedTableColumns[0].cellParamName])}
          onChange={event => handleCheckboxChange(fixedTableColumns[0].cellParamName)(event)}
        />
      </Grid>
      <Grid item container justifyContent='center' xs={12} sx={{ minHeight: 16 }}>
        {scheduleCellParamColumns?.map((column, index) => {
          if (selectedOptions && selectedOptions[cellData.Index] && selectedOptions[cellData.Index][column.cellParamName])
            return <ColoredCircle key={index} colorIndex={index} sx={theme => ({ fontSize: theme.spacing(1.5) })} />;
        })}
      </Grid>
      <Grid item xs={12}>
        <Tooltip
          title={
            labelValues?.length
              ? labelValues.map((value, index) => (
                  <Grid key={index} container justifyContent={'space-between'} gap={2}>
                    <Typography>{value.cellParamDisplayName}</Typography>
                    <Typography>
                      {t('DECIMAL', {
                        number: cellData[value.cellParamName]
                      })}
                    </Typography>
                  </Grid>
                ))
              : ''
          }
        >
          <CalendarTableCellChip
            color='primary'
            size='small'
            label={`${t('OfferEdit.PaymentPlan.Rate')} ${cellData[fixedTableColumns[1].cellParamName]}`}
          />
        </Tooltip>
      </Grid>
    </Grid>
  );
}

ScheduleTableCell.propTypes = {
  rowIdx: PropTypes.number.isRequired,
  cellData: PropTypes.object.isRequired,
  fixedTableColumns: PropTypes.array.isRequired,
  handleRowPropertyChange: PropTypes.func.isRequired,
  scheduleCellParamColumns: PropTypes.array,
  selectedOptions: PropTypes.array.isRequired
};

export default ScheduleTableCell;
